module.exports = __webpack_public_path__ + "img/30292-9.prt.37a6a156.jpg";